import { createSelector } from '@reduxjs/toolkit';
import { IState } from 'core';
import { IWinnerState } from './types';

const winnerItemSelector = (state: IState) => state.winnerReducer;

export const winnerSelector = createSelector(
  winnerItemSelector,
  (state: IWinnerState) => state.winner,
);
